import React from "react";
import { BrowserRouter as Router} from 'react-router-dom';

//import components
import { MyRoutes } from "./routes";


//import assets

function App() {

  return (
      <div 
        className="App" 
      >
          <Router>
            <MyRoutes />
            
          </Router>
      </div>
      
  );
}

export default App;